export const PAYPAL_BUTTON_CONTAINER_ID = 'paypal-button-container'
